// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hr_Wrapper__mSPAF","Text":"Hr_Text__dMO8Q","Line":"Hr_Line__YczK1"};